import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ICONS } from '@app/styles';
import { _className, AwaitModules, LL_H_C } from '@nu-art/thunderstorm-frontend';
import { useEffect, useRef, useState } from 'react';
import { Component_FindingsButton } from '../Component_FindingsButton/Component_FindingsButton.js';
import { Component_SL_Button } from '@app/styles/skeleton-loaders';
import './Component_HomeFooter.scss';
import { ModuleFE_AdvisorMini } from '../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_Home } from '@app/advisor-v5-shared';
import { Component_InboxButton } from '../Component_InboxButton/Component_InboxButton.js';
import { Component_EventFeedButton } from '../Component_EventFeedButton/Component_EventFeedButton.js';
import { Component_LiveMDMButton } from '../Component_LiveMDMButton/Component_LiveMDMButton.js';
const parsePx = (value) => Number.parseFloat(value) || 0;
const Component_HomeFooterContent = () => {
    const ref = useRef(null);
    const [iconOnly, setIconOnly] = useState(false);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const updateIconOnly = () => {
            const styles = getComputedStyle(el);
            const gapPx = parsePx(styles.getPropertyValue('--home-footer-gap'));
            const liveMdmWidthPx = parsePx(styles.getPropertyValue('--live-mdm-width'));
            const utilityButtonWidthPx = parsePx(styles.getPropertyValue('--utility-button-width'));
            const utilityCount = el.querySelectorAll('.c__utility-button').length;
            const utilityNeeded = utilityCount === 0
                ? 0
                : utilityCount * utilityButtonWidthPx + Math.max(utilityCount - 1, 0) * gapPx;
            const needed = liveMdmWidthPx + (utilityCount ? gapPx : 0) + utilityNeeded;
            const nextIconOnly = el.clientWidth < needed;
            setIconOnly(prev => prev === nextIconOnly ? prev : nextIconOnly);
        };
        const resizeObserver = new ResizeObserver(updateIconOnly);
        const mutationObserver = new MutationObserver(updateIconOnly);
        resizeObserver.observe(el);
        mutationObserver.observe(el, { childList: true, subtree: true });
        updateIconOnly();
        return () => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, []);
    return _jsxs(LL_H_C, { innerRef: ref, className: _className('home-footer-content', iconOnly && 'icon-only'), children: [_jsx(Component_LiveMDMButton, { forceFallback: iconOnly }), _jsxs("div", { className: 'home-footer-utility-buttons', children: [_jsx(Component_FindingsButton, { forceFallback: iconOnly }), _jsx(Component_InboxButton, { forceFallback: iconOnly }), _jsx(Component_EventFeedButton, { forceFallback: iconOnly })] })] });
};
const Component_AdvisorSL_Footer = () => _jsxs(LL_H_C, { className: 'c-asl-footer', children: [_jsx(Component_SL_Button, {}), _jsx(Component_SL_Button, {}), _jsx(Component_SL_Button, {}), _jsx(Component_SL_Button, {})] });
export const Component_HomeFooter = () => _jsxs(LL_H_C, { className: 'c__home-footer', children: [_jsx(ICONS.advisor_v5_logoWithName.component, { onClick: () => ModuleFE_AdvisorMini.openPanel(PanelKey_Home) }), _jsx(AwaitModules, { modules: [...Component_FindingsButton.modulesToAwait, ...Component_LiveMDMButton.modulesToAwait], customLoader: Component_AdvisorSL_Footer, Component: () => _jsx(Component_HomeFooterContent, {}) })] });
//# sourceMappingURL=Component_HomeFooter.js.map